module.exports = __webpack_public_path__ + "media/images/support-d71d5885d1c08292ad431ec785fd5b5e.png";